import { IMeta } from '../i-meta';

export class Page implements IMeta {
    public Label: string = '';
    public Data = {};
    public IsFave: boolean;
    
    constructor(label: string) {
        this.Label = label;     
        this.Data = {};
        this.IsFave = false;
    }

    public copyFrom(page: Page) {
        if (!!page) {          
            this.Data = page.Data;
            this.Label = page.Label;
            this.IsFave = page.IsFave;
        }
    }
}


